define('app/sf/diff/sf-diff-filter',[],function () {
	function _diff(x, y) {
		if (!angular.isObject(x) || !angular.isObject(y)) {
			return {
				x: angular.copy(x),
				y: angular.copy(y)
			};
		}
		var xKeys = Object.keys(x),
			yKeys = Object.keys(y),
			diff = {},
			isDiff = false,
			allKeys = xKeys.filter(function (k) {
				return yKeys.indexOf(k) < 0;
			}).concat(yKeys);
		angular.forEach(allKeys, function (key) {
			if (x[key] !== y[key]) {
				isDiff = true;
				diff[key] = _diff(x[key], y[key]);
			}
		});
		return isDiff ? diff : undefined;
	}
	return function diffFilter(input, compareTo) {
		return _diff(input, compareTo);
	};
});
